// @flow
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

import {
    getAllSyncJobs as getAllSyncJobsApi,
} from '../../helpers/';

import { syncJobsApiResponseSuccess, syncJobsApiResponseError } from './actions';
import { SyncJobsActionTypes } from './constants';
import { syncJobResponseToSyncJobObject } from '../../helpers/mappers/syncJob';
import { addToast } from '../actions';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';

function* getAllSyncJobs({ payload: { query } }) {
    try {
        const getAllSyncJobsResponse = yield call(getAllSyncJobsApi, query);
        const syncJobs = getAllSyncJobsResponse.data.map((syncJobResponse) => syncJobResponseToSyncJobObject(syncJobResponse));
        const pagination = { ...paginationHeadersResponse(getAllSyncJobsResponse.headers), ...query };
        yield put(syncJobsApiResponseSuccess(SyncJobsActionTypes.GET_ALL_SYNC_JOBS, { syncJobs, pagination }));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(syncJobsApiResponseError(SyncJobsActionTypes.GET_ALL_SYNC_JOBS, error));
    }
}

export function* watchGetAllSyncJobs(): any {
    yield takeLatest(SyncJobsActionTypes.GET_ALL_SYNC_JOBS, getAllSyncJobs);
}

function* syncJobsSaga(): any {
    yield all([
        fork(watchGetAllSyncJobs),
    ]);
}

export default syncJobsSaga;
